<template>

	 <section class="section section-lg pt-lg-0 mt--200"> 	
	 	     <div class="text-center">
            		<h2 class="display-2">Our Services</h2>

            	</div>
                <br>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">

                        <div class="row row-grid">
                            <div class="col-lg-4">
                                <card class="border-0 text-center" hover shadow body-classes="py-5">
                                    <icon name="ni ni-tv-2" type="primary" rounded class="mb-4 ">
                                    </icon>
                                    <h6 class="text-primary ">Zero-Inside Software Dev</h6>
                                    <p class="description mt-3">Menawarkan solusi IT bagi Anda dengan membuat aplikasi sesuai dengan kebutuhan mulai dari website, mobile apps, maupun desktop.  </p>
                                    <div>

                                            <badge type="primary" rounded>Customize Website</badge>
                    
                                            <badge type="primary" rounded>Corporate Website</badge>
                                 
                                            <badge type="primary" rounded>Web Based Application</badge>
                                        
                                            <badge type="primary" rounded>Mobile Application</badge>
                                     
                                            <badge type="primary" rounded>Desktop Application</badge>
                                    
                                            <badge type="primary" rounded>Internet of Things </badge>
                                 
                                    </div>
                                    <base-button tag="a" href="/software-dev" type="primary" class="mt-4">
                                        See more
                                    </base-button>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0 text-center" hover shadow body-classes="py-5">
                                    <icon name="ni ni-camera-compact" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary ">Zero-Inside Studio</h6>
                                    <p class="description mt-3"> Menyediakan peralatan dan jasa untuk kebutuhan dokumentasi serta membuat digital produk untuk branding mulai dari logo, desain, sampai video. </p>
                                  <div>
                            
                                            <badge type="primary" rounded>Design Logo, Banner, Flyer</badge>
                                      
                                            <badge type="primary" rounded>Foto dan Video Produk </badge>
                                        
                                            <badge type="primary" rounded>Foto dan Video Corporate</badge>
                                     
                                            <badge type="primary" rounded>Sewa Camera, Tripod</badge>
                                       
                                            <badge type="primary" rounded>Aerial Video</badge>
                                      
                                    </div>
                                    <base-button tag="a" href="/studio" type="primary" class="mt-4">
                                        See more
                                    </base-button>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0 text-center" hover shadow body-classes="py-5">
                                    <icon name="ni ni-laptop" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary ">Zero-Inside Repairment</h6>
                                    <p class="description mt-3"> Memperbaiki dan merawat laptop/komputer Anda dari kerusakan software ataupun hardware serta menginstall berbagai aplikasi baik di Windows, Linux, ataupun Mac. </p>
                                    <div>
                                        
                                            <badge type="primary" rounded>Install Ulang</badge>
                                 
                                            <badge type="primary" rounded>Install Software </badge>
                                      
                                            <badge type="primary" rounded>Windows</badge>
                                
                                            <badge type="primary" rounded>Mac OS X</badge>
                                    
                                            <badge type="primary" rounded>Linux</badge>
                               
                                    </div>
                                    <base-button tag="a" href="/repairment" type="primary" class="mt-4">
                                        See more
                                    </base-button>
                                </card>
                            </div>

                            
                        </div>
                        
                    </div>
                </div>
            </div>
        </section>
</template>
<script>
export default {};
</script>